var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":"新增标签","visible":_vm.isAddTagModalVisible,"confirm-loading":_vm.pointTagconfirmLoading,"okText":"保 存","cancelText":"取 消","width":"892px"},on:{"ok":_vm.addTaghandleOk,"cancel":_vm.addTaghandleCancel}},[_c('a-transfer',{attrs:{"data-source":_vm.addTagList,"target-keys":_vm.targetKeys,"show-search":true,"filter-option":function (inputValue, item) { return item.description.indexOf(inputValue) !== -1 ||item.title.indexOf(inputValue) !== -1; },"show-select-all":false,"titles":['标签库', '已选标签'],"placeholder":"请输入标签组名称"},on:{"change":_vm.onChangeTransfer},scopedSlots:_vm._u([{key:"children",fn:function(ref){
      var ref_props = ref.props;
      var direction = ref_props.direction;
      var filteredItems = ref_props.filteredItems;
      var selectedKeys = ref_props.selectedKeys;
      var listDisabled = ref_props.disabled;
      var ref_on = ref.on;
      var itemSelectAll = ref_on.itemSelectAll;
      var itemSelect = ref_on.itemSelect;
return [_c('a-table',{style:({ pointerEvents: listDisabled ? 'none' : null }),attrs:{"row-selection":_vm.getRowSelection({
            disabled: listDisabled,
            selectedKeys: selectedKeys,
            itemSelectAll: itemSelectAll,
            itemSelect: itemSelect,

          },direction),"columns":direction === 'left' ? _vm.addTagLeftColumns : _vm.addTagRightColumns,"data-source":filteredItems,"size":"small","custom-row":function (ref) {
                var key = ref.key;
                var itemDisabled = ref.disabled;

                return ({
            on: {
              click: function () {
                if (itemDisabled || listDisabled) { return }
                itemSelect(key, !selectedKeys.includes(key))
              },
            },
          });
      }},scopedSlots:_vm._u([{key:"description",fn:function(text, record, index){return [_c('a-tag',[_vm._v(_vm._s(text))])]}}],null,true)})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }